import { LyMainProductFormBase } from "./base"

if (!customElements.get('ly-main-product-form-total-price')) {
    customElements.define('ly-main-product-form-total-price', class extends LyMainProductFormBase {
        installationServicePrice = 0

        get primaryCurrentPrice() {
            return this.getCurrentPrice(this) * this.primaryQuantity
        }

        get primaryOriginalPrice() {
            return this.getOriginalPrice(this) * this.primaryQuantity
        }

        get primaryQuantity() {
            return +(this.primaryQuantityInput?.value || 1)
        }

        get sidewallCurrentPrice() {
            return this.sidewallCheckedInputs
                .map(i => this.getCurrentPrice(i))
                .reduce((a, b) => a + b, 0)
        }

        get sidewallOriginalPrice() {
            return this.sidewallCheckedInputs
                .map(i => this.getOriginalPrice(i))
                .reduce((a, b) => a + b, 0)
        }

        get sidewallAccessoryCurrentPrice() {
            return this.sidewallAccessoryCheckedInputs
                .map(i => this.getCurrentPrice(i))
                .reduce((a, b) => a + b, 0)
        }

        get sidewallAccessoryOriginalPrice() {
            return this.sidewallAccessoryCheckedInputs
                .map(i => this.getOriginalPrice(i))
                .reduce((a, b) => a + b, 0)
        }

        get accessoriesCurrentPrice() {
            return this.accessoryCheckedResult
                .map(item => this.accessoryPriceCalculator(item, this.getCurrentPrice))
                .reduce((a, b) => a + b, 0)
        }

        get accessoriesOriginalPrice() {
            return this.accessoryCheckedResult
                .map(item => this.accessoryPriceCalculator(item, this.getOriginalPrice))
                .reduce((a, b) => a + b, 0)
        }

        accessoryPriceCalculator = (item, getPriceFn) => {
            const p = getPriceFn(item.checkedInput)
            const quantity = +(item.quantityInput.value || 1)
            const freeCount = +item.quantityInput.dataset.freeCount
            return Math.max(0, p * (quantity - freeCount))
        }

        get totalCurrentPrice() {
            return this.primaryCurrentPrice +
                this.sidewallCurrentPrice +
                this.sidewallAccessoryCurrentPrice +
                this.accessoriesCurrentPrice +
                this.installationServicePrice
        }

        get totalOriginalPrice() {
            return this.primaryOriginalPrice +
                this.sidewallOriginalPrice +
                this.sidewallAccessoryOriginalPrice +
                this.accessoriesOriginalPrice +
                this.installationServicePrice
        }

        get totalDiscountMoney() {
            return this.totalOriginalPrice - this.totalCurrentPrice
        }

        get totalDiscountRatio() {
            const discountRatio = (this.totalCurrentPrice * 100) / this.totalOriginalPrice
            const discountPercent = 100 - discountRatio

            return discountPercent.toFixed(0) + '%'
        }

        connectedCallback() {
            super.connectedCallback()

            this.totalCurrentPriceDom = this.querySelector('[data-current-pirce]')
            this.totalOriginalPriceDom = this.querySelector('[data-original-pirce]')
            this.totalDiscountWrapper = this.querySelector('[data-discount-wrapper]')
            this.totalDiscountMoneyDom = this.totalDiscountWrapper.querySelector('[data-discount-money]')
            this.totalDiscountRatioDom = this.totalDiscountWrapper.querySelector('[data-discount-ratio]')

            this.primaryQuantityInput = this.queryWrapper.querySelector('.ly-main-product-form-quantity-picker ly-quantity-input input')

            this.sidewallChangeUnsubscriber = window.subscribe('bus:sidewall_picker_changed', this.debouncedUpdate)
            this.sidewallAccessoryChangeUnsubscriber = window.subscribe('bus:sidewall_accessory_picker_changed', this.debouncedUpdate)
            this.accessoryChangeUnsubscriber = window.subscribe('bus:accessory_picker_changed', this.debouncedUpdate)
            this.accessoryQuantityChangeUnsubscriber = window.subscribe('bus:accessory_picker_quantity_changed', this.debouncedUpdate)
            this.installationServiceChangeUnsubscriber = window.subscribe('bus:installation_service_picker_changed', this.handleInstallationServiceChange)

            this.primaryQuantityInput?.addEventListener('change', this.debouncedUpdate)

            requestAnimationFrame(() => {
                this.update()
            })
        }

        disconnectedCallback() {
            this.sidewallChangeUnsubscriber?.()
            this.sidewallAccessoryChangeUnsubscriber?.()
            this.accessoryChangeUnsubscriber?.()
            this.accessoryQuantityChangeUnsubscriber?.()
            this.installationServiceChangeUnsubscriber?.()

            this.primaryQuantityInput?.removeEventListener('change', this.debouncedUpdate)

            super.disconnectedCallback()
        }

        update = () => {
            const { totalCurrentPrice, totalOriginalPrice, totalDiscountMoney } = this

            this.totalCurrentPriceDom.textContent = this.formatter.format(totalCurrentPrice / 100)

            const noChange = totalCurrentPrice === totalOriginalPrice

            this.totalOriginalPriceDom.textContent = this.formatter.format(totalOriginalPrice / 100)
            this.totalOriginalPriceDom.classList.toggle('ly-hide', noChange)

            this.totalDiscountWrapper.classList.toggle('ly-hide', noChange)
            if (this.totalDiscountMoneyDom) {
                this.totalDiscountMoneyDom.textContent = this.formatter.format(totalDiscountMoney / 100)
            }

            if (this.totalDiscountRatioDom) {
                this.totalDiscountRatioDom.textContent = this.totalDiscountRatio
            }

            window.publish('bus:total_price_changed', { totalCurrentPrice, totalOriginalPrice, totalDiscountMoney })
        }

        debouncedUpdate = debounce(this.update, 300)

        handleInstallationServiceChange = ({ checked, price }) => {
            this.installationServicePrice = checked ? price : 0
            this.debouncedUpdate()
        }

        _onVariantChange = ({ variantId }) => {
            const config = this._variantConfigs[variantId]

            if (!config) return
            const { current, original } = config

            this.dataset.currentPrice = current
            this.dataset.originalPrice = original

            requestAnimationFrame(() => {
                this.update()
            })
        }
    })
}